(() => {
  'use strict';
  if (document.documentElement.lang !== 'en' || customElements.get('nv-delivery-estimate')) return;
  // One request per SKU, shared by PDP, drawer and responsive checkout summaries.
  const cache = new Map();
  function inventory(sku) {
    const found = cache.get(sku);
    if (found && Date.now() - found.at < 60000) return found.promise;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 8000);
    const promise = fetch('/a/api/inventory?storecard_id=' + encodeURIComponent(sku), {signal: controller.signal})
      .then(response => { if (!response.ok) throw new Error('Inventory unavailable'); return response.json(); })
      .then(data => {
        if (!Array.isArray(data) || (data.length && (data[0].quantity == null || !Number.isFinite(Number(data[0].quantity))))) throw new Error('Invalid inventory');
        return data.length ? Number(data[0].quantity) : 0;
      }).catch(error => { cache.delete(sku); throw error; }).finally(() => clearTimeout(timer));
    cache.set(sku, {at: Date.now(), promise});
    return promise;
  }
  class DeliveryEstimate extends HTMLElement {
    static get observedAttributes() { return ['data-sku']; }
    connectedCallback() { this.update(); }
    attributeChangedCallback() { if (this.isConnected) this.update(); }
    async update() {
      const version = this.version = (this.version || 0) + 1;
      const label = this.querySelector('[data-delivery-label]');
      if (!label) return;
      const set = (text, state) => {
        if (this.version !== version || !this.isConnected) return;
        label.textContent = text; this.dataset.state = state;
      };
      const {sku, shipWeek, shipDays, override} = this.dataset;
      if (override) { set(override, 'production'); return; }
      if (shipWeek === 'true' || !sku) { set('Dispatch in 1–3 weeks.', 'production'); return; }
      set('Checking availability…', 'loading');
      try {
        const quantity = await inventory(sku);
        if (quantity < 5) {
          set(shipDays === 'true' ? 'Dispatch in 1–3 weeks.' : 'Made to order — production takes 4–14 weeks.', 'production');
        } else {
          set(shipDays === 'true' ? 'In stock — dispatch within 3 days.' : 'In stock — dispatch within 1 week.', 'stock');
        }
      } catch {
        set('Availability could not be confirmed. Please contact us before ordering.', 'unknown');
      }
    }
  }
  customElements.define('nv-delivery-estimate', DeliveryEstimate);
})();
